<template>
  <el-dialog
      :model-value="props.visible"
      title="选择人员权限"
      width="600"
      top="6vh"
      destroy-on-close
      :close-on-click-modal="false"
      @open="onOpen"
      @closed="closedModal"
  >
    <div v-loading="pageLoading">
      <div class="wrap">

        <el-checkbox
            v-model="checkAll"
            style="opacity: 0.6;"
            label="全选" size="large"/>


        <el-checkbox-group
            v-model="checkList"
            class="my-check-list-block"
        >
          <el-checkbox label="涉税办理" value="涉税办理"/>
          <el-checkbox label="税费申报" value="税费申报"/>
          <el-checkbox label="涉税查询" value="涉税查询"/>
          <el-checkbox label="发票业务" value="发票业务"/>
          <el-checkbox label="公共业务功能集合" value="公共业务功能集合"/>
          <el-checkbox label="乐企功能集" value="乐企功能集"/>
        </el-checkbox-group>
      </div>

      <div class="my-footer">
        <el-button @click="emit('update:visible', false)">取消</el-button>
        <el-button type="primary" style="margin-right: 15px;" @click="onConfirm">确认</el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script setup>
import {ElMessage} from "element-plus";


const props = defineProps({
  visible: {
    type: Boolean,
    required: true
  },
  initialCheckList: {
    type: String,
    default: ''
  },
})

const pageLoading = ref(false)
const formData = ref({})
const checkList = ref([])
const checkAll = computed({
  get: () => {
    return checkList.value.sort((a, b) => a.localeCompare(b, 'zh-Hans-CN', {sensitivity: 'accent'})).join(',')
        == '发票业务,公共业务功能集合,乐企功能集,涉税办理,涉税查询,税费申报'
  },
  set: val => {
    if (val) {
      checkList.value = ['涉税办理', '税费申报', '涉税查询', '发票业务', '公共业务功能集合', '乐企功能集']
    } else {
      checkList.value = []
    }
  }
})

function onOpen() {
  checkList.value = props.initialCheckList && props.initialCheckList.split(',') || []
}

const formRef = ref()

const emit = defineEmits(['update:visible', 'confirm'])

async function onConfirm() {
  if (!checkList.value.length) {
    ElMessage.warning('人员权限不能为空')
    return
  }
  emit('confirm', checkList.value.sort((a, b) => a.localeCompare(b, 'zh-Hans-CN', {sensitivity: 'accent'})).join(','))
  emit('update:visible', false)
}

function closedModal() {
  emit('update:visible', false)
  checkList.value = []
  formData.value = {}
}
</script>

<style scoped lang="scss">
.my-footer {
  display: flex;
  flex-direction: row-reverse;
  margin-top: 30px;
}

.wrap {
  :deep(.my-check-list-block) {
    padding-left: 20px;

    .el-checkbox {
      display: flex;
      align-items: center;
    }
  }
}
</style>
